export const SetupGraphic = (
  <svg
    width="1065"
    height="365"
    viewBox="0 0 1065 365"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-full"
  >
    <rect width="1064" height="364" transform="translate(0 1)" fill="#F9FAFB" />
    <rect y="1" width="637" height="44" rx="4" fill="#E2EBEB" />
    <path
      d="M36.5 25.5L34.8333 29.6667L31.5 20.5L40.6667 23.8333L36.5 25.5ZM36.5 25.5L40.6667 29.6667M29.99 14.8658L30.6375 17.28M28.28 19.6375L25.865 18.99M35.625 16.375L33.8567 18.1433M29.1425 22.8567L27.3758 24.625"
      stroke="#006265"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      fill="#134E4A"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      className="font-sans"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="52" y="27.97">
        You automate this task
      </tspan>
    </text>
    <g opacity="0.2">
      <rect x="216" y="225" width="637" height="44" rx="4" fill="#EEF2FF" />
      <path
        d="M247.273 248.318C247.093 248.318 246.917 248.371 246.768 248.471C246.618 248.571 246.502 248.713 246.433 248.879C246.364 249.045 246.346 249.228 246.381 249.405C246.416 249.581 246.503 249.743 246.63 249.87C246.757 249.997 246.919 250.084 247.095 250.119C247.272 250.154 247.455 250.136 247.621 250.067C247.787 249.998 247.929 249.882 248.029 249.732C248.128 249.583 248.182 249.407 248.182 249.227C248.182 248.986 248.086 248.755 247.916 248.584C247.745 248.414 247.514 248.318 247.273 248.318ZM240.909 247.409C240.668 247.409 240.437 247.505 240.266 247.675C240.096 247.846 240 248.077 240 248.318V250.136C240 250.377 240.096 250.609 240.266 250.779C240.437 250.95 240.668 251.045 240.909 251.045C241.15 251.045 241.381 250.95 241.552 250.779C241.722 250.609 241.818 250.377 241.818 250.136V248.318C241.818 248.077 241.722 247.846 241.552 247.675C241.381 247.505 241.15 247.409 240.909 247.409ZM259.091 247.409C258.85 247.409 258.619 247.505 258.448 247.675C258.278 247.846 258.182 248.077 258.182 248.318V250.136C258.182 250.377 258.278 250.609 258.448 250.779C258.619 250.95 258.85 251.045 259.091 251.045C259.332 251.045 259.563 250.95 259.734 250.779C259.904 250.609 260 250.377 260 250.136V248.318C260 248.077 259.904 247.846 259.734 247.675C259.563 247.505 259.332 247.409 259.091 247.409ZM254.545 241.045H250.909V239.882C251.184 239.723 251.412 239.495 251.572 239.221C251.731 238.947 251.816 238.635 251.818 238.318C251.818 237.836 251.627 237.374 251.286 237.033C250.945 236.692 250.482 236.5 250 236.5C249.518 236.5 249.055 236.692 248.714 237.033C248.373 237.374 248.182 237.836 248.182 238.318C248.184 238.635 248.269 238.947 248.428 239.221C248.588 239.495 248.816 239.723 249.091 239.882V241.045H245.455C244.731 241.045 244.038 241.333 243.526 241.844C243.015 242.356 242.727 243.049 242.727 243.773V251.955C242.727 252.678 243.015 253.372 243.526 253.883C244.038 254.394 244.731 254.682 245.455 254.682H254.545C255.269 254.682 255.962 254.394 256.474 253.883C256.985 253.372 257.273 252.678 257.273 251.955V243.773C257.273 243.049 256.985 242.356 256.474 241.844C255.962 241.333 255.269 241.045 254.545 241.045ZM251.564 242.864L251.109 244.682H248.891L248.436 242.864H251.564ZM255.455 251.955C255.455 252.196 255.359 252.427 255.188 252.597C255.018 252.768 254.787 252.864 254.545 252.864H245.455C245.213 252.864 244.982 252.768 244.812 252.597C244.641 252.427 244.545 252.196 244.545 251.955V243.773C244.545 243.532 244.641 243.3 244.812 243.13C244.982 242.959 245.213 242.864 245.455 242.864H246.564L247.273 245.809C247.323 246.011 247.44 246.189 247.605 246.315C247.771 246.441 247.974 246.506 248.182 246.5H251.818C252.026 246.506 252.229 246.441 252.395 246.315C252.56 246.189 252.677 246.011 252.727 245.809L253.436 242.864H254.545C254.787 242.864 255.018 242.959 255.188 243.13C255.359 243.3 255.455 243.532 255.455 243.773V251.955ZM252.727 248.318C252.547 248.318 252.372 248.371 252.222 248.471C252.073 248.571 251.956 248.713 251.887 248.879C251.819 249.045 251.801 249.228 251.836 249.405C251.871 249.581 251.957 249.743 252.084 249.87C252.212 249.997 252.374 250.084 252.55 250.119C252.726 250.154 252.909 250.136 253.075 250.067C253.241 249.998 253.383 249.882 253.483 249.732C253.583 249.583 253.636 249.407 253.636 249.227C253.636 248.986 253.541 248.755 253.37 248.584C253.2 248.414 252.968 248.318 252.727 248.318Z"
        fill="#5B21B6"
      />
      <rect
        x="268"
        y="239"
        width="350"
        height="16"
        rx="2"
        fill="#3730A3"
        fillOpacity="0.3"
      />
      <text
        fill="#6D28D9"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Flow Block"
        fontSize="12"
        letterSpacing="0em"
      >
        <tspan x="768" y="251.8">
          AUTOMATED
        </tspan>
      </text>
    </g>
    <g opacity="0.4">
      <rect x="160" y="169" width="637" height="44" rx="4" fill="#EEF2FF" />
      <path
        d="M191.273 192.318C191.093 192.318 190.917 192.371 190.768 192.471C190.618 192.571 190.502 192.713 190.433 192.879C190.364 193.045 190.346 193.228 190.381 193.405C190.416 193.581 190.503 193.743 190.63 193.87C190.757 193.997 190.919 194.084 191.095 194.119C191.272 194.154 191.455 194.136 191.621 194.067C191.787 193.998 191.929 193.882 192.029 193.732C192.128 193.583 192.182 193.407 192.182 193.227C192.182 192.986 192.086 192.755 191.916 192.584C191.745 192.414 191.514 192.318 191.273 192.318ZM184.909 191.409C184.668 191.409 184.437 191.505 184.266 191.675C184.096 191.846 184 192.077 184 192.318V194.136C184 194.377 184.096 194.609 184.266 194.779C184.437 194.95 184.668 195.045 184.909 195.045C185.15 195.045 185.381 194.95 185.552 194.779C185.722 194.609 185.818 194.377 185.818 194.136V192.318C185.818 192.077 185.722 191.846 185.552 191.675C185.381 191.505 185.15 191.409 184.909 191.409ZM203.091 191.409C202.85 191.409 202.619 191.505 202.448 191.675C202.278 191.846 202.182 192.077 202.182 192.318V194.136C202.182 194.377 202.278 194.609 202.448 194.779C202.619 194.95 202.85 195.045 203.091 195.045C203.332 195.045 203.563 194.95 203.734 194.779C203.904 194.609 204 194.377 204 194.136V192.318C204 192.077 203.904 191.846 203.734 191.675C203.563 191.505 203.332 191.409 203.091 191.409ZM198.545 185.045H194.909V183.882C195.184 183.723 195.412 183.495 195.572 183.221C195.731 182.947 195.816 182.635 195.818 182.318C195.818 181.836 195.627 181.374 195.286 181.033C194.945 180.692 194.482 180.5 194 180.5C193.518 180.5 193.055 180.692 192.714 181.033C192.373 181.374 192.182 181.836 192.182 182.318C192.184 182.635 192.269 182.947 192.428 183.221C192.588 183.495 192.816 183.723 193.091 183.882V185.045H189.455C188.731 185.045 188.038 185.333 187.526 185.844C187.015 186.356 186.727 187.049 186.727 187.773V195.955C186.727 196.678 187.015 197.372 187.526 197.883C188.038 198.394 188.731 198.682 189.455 198.682H198.545C199.269 198.682 199.962 198.394 200.474 197.883C200.985 197.372 201.273 196.678 201.273 195.955V187.773C201.273 187.049 200.985 186.356 200.474 185.844C199.962 185.333 199.269 185.045 198.545 185.045ZM195.564 186.864L195.109 188.682H192.891L192.436 186.864H195.564ZM199.455 195.955C199.455 196.196 199.359 196.427 199.188 196.597C199.018 196.768 198.787 196.864 198.545 196.864H189.455C189.213 196.864 188.982 196.768 188.812 196.597C188.641 196.427 188.545 196.196 188.545 195.955V187.773C188.545 187.532 188.641 187.3 188.812 187.13C188.982 186.959 189.213 186.864 189.455 186.864H190.564L191.273 189.809C191.323 190.011 191.44 190.189 191.605 190.315C191.771 190.441 191.974 190.506 192.182 190.5H195.818C196.026 190.506 196.229 190.441 196.395 190.315C196.56 190.189 196.677 190.011 196.727 189.809L197.436 186.864H198.545C198.787 186.864 199.018 186.959 199.188 187.13C199.359 187.3 199.455 187.532 199.455 187.773V195.955ZM196.727 192.318C196.547 192.318 196.372 192.371 196.222 192.471C196.073 192.571 195.956 192.713 195.887 192.879C195.819 193.045 195.801 193.228 195.836 193.405C195.871 193.581 195.957 193.743 196.084 193.87C196.212 193.997 196.374 194.084 196.55 194.119C196.726 194.154 196.909 194.136 197.075 194.067C197.241 193.998 197.383 193.882 197.483 193.732C197.583 193.583 197.636 193.407 197.636 193.227C197.636 192.986 197.541 192.755 197.37 192.584C197.2 192.414 196.968 192.318 196.727 192.318Z"
        fill="#5B21B6"
      />
      <rect
        x="212"
        y="183"
        width="283"
        height="16"
        rx="2"
        fill="#3730A3"
        fillOpacity="0.3"
      />
      <rect x="703" y="188" width="64" height="6" rx="2" fill="#8B5CF6" />
    </g>
    <g opacity="0.6">
      <rect x="104" y="113" width="637" height="44" rx="4" fill="#EEF2FF" />
      <path
        d="M135.273 136.318C135.093 136.318 134.917 136.371 134.768 136.471C134.618 136.571 134.502 136.713 134.433 136.879C134.364 137.045 134.346 137.228 134.381 137.405C134.416 137.581 134.503 137.743 134.63 137.87C134.757 137.997 134.919 138.084 135.095 138.119C135.272 138.154 135.455 138.136 135.621 138.067C135.787 137.998 135.929 137.882 136.029 137.732C136.128 137.583 136.182 137.407 136.182 137.227C136.182 136.986 136.086 136.755 135.916 136.584C135.745 136.414 135.514 136.318 135.273 136.318ZM128.909 135.409C128.668 135.409 128.437 135.505 128.266 135.675C128.096 135.846 128 136.077 128 136.318V138.136C128 138.377 128.096 138.609 128.266 138.779C128.437 138.95 128.668 139.045 128.909 139.045C129.15 139.045 129.381 138.95 129.552 138.779C129.722 138.609 129.818 138.377 129.818 138.136V136.318C129.818 136.077 129.722 135.846 129.552 135.675C129.381 135.505 129.15 135.409 128.909 135.409ZM147.091 135.409C146.85 135.409 146.619 135.505 146.448 135.675C146.278 135.846 146.182 136.077 146.182 136.318V138.136C146.182 138.377 146.278 138.609 146.448 138.779C146.619 138.95 146.85 139.045 147.091 139.045C147.332 139.045 147.563 138.95 147.734 138.779C147.904 138.609 148 138.377 148 138.136V136.318C148 136.077 147.904 135.846 147.734 135.675C147.563 135.505 147.332 135.409 147.091 135.409ZM142.545 129.045H138.909V127.882C139.184 127.723 139.412 127.495 139.572 127.221C139.731 126.947 139.816 126.635 139.818 126.318C139.818 125.836 139.627 125.374 139.286 125.033C138.945 124.692 138.482 124.5 138 124.5C137.518 124.5 137.055 124.692 136.714 125.033C136.373 125.374 136.182 125.836 136.182 126.318C136.184 126.635 136.269 126.947 136.428 127.221C136.588 127.495 136.816 127.723 137.091 127.882V129.045H133.455C132.731 129.045 132.038 129.333 131.526 129.844C131.015 130.356 130.727 131.049 130.727 131.773V139.955C130.727 140.678 131.015 141.372 131.526 141.883C132.038 142.394 132.731 142.682 133.455 142.682H142.545C143.269 142.682 143.962 142.394 144.474 141.883C144.985 141.372 145.273 140.678 145.273 139.955V131.773C145.273 131.049 144.985 130.356 144.474 129.844C143.962 129.333 143.269 129.045 142.545 129.045ZM139.564 130.864L139.109 132.682H136.891L136.436 130.864H139.564ZM143.455 139.955C143.455 140.196 143.359 140.427 143.188 140.597C143.018 140.768 142.787 140.864 142.545 140.864H133.455C133.213 140.864 132.982 140.768 132.812 140.597C132.641 140.427 132.545 140.196 132.545 139.955V131.773C132.545 131.532 132.641 131.3 132.812 131.13C132.982 130.959 133.213 130.864 133.455 130.864H134.564L135.273 133.809C135.323 134.011 135.44 134.189 135.605 134.315C135.771 134.441 135.974 134.506 136.182 134.5H139.818C140.026 134.506 140.229 134.441 140.395 134.315C140.56 134.189 140.677 134.011 140.727 133.809L141.436 130.864H142.545C142.787 130.864 143.018 130.959 143.188 131.13C143.359 131.3 143.455 131.532 143.455 131.773V139.955ZM140.727 136.318C140.547 136.318 140.372 136.371 140.222 136.471C140.073 136.571 139.956 136.713 139.887 136.879C139.819 137.045 139.801 137.228 139.836 137.405C139.871 137.581 139.957 137.743 140.084 137.87C140.212 137.997 140.374 138.084 140.55 138.119C140.726 138.154 140.909 138.136 141.075 138.067C141.241 137.998 141.383 137.882 141.483 137.732C141.583 137.583 141.636 137.407 141.636 137.227C141.636 136.986 141.541 136.755 141.37 136.584C141.2 136.414 140.968 136.318 140.727 136.318Z"
        fill="#5B21B6"
      />
      <rect
        x="156"
        y="127"
        width="408"
        height="16"
        rx="2"
        fill="#3730A3"
        fillOpacity="0.3"
      />
      <rect x="647" y="132" width="64" height="6" rx="2" fill="#8B5CF6" />
    </g>
    <rect
      x="288"
      y="104"
      width="579"
      height="194.333"
      fill="url(#paint0_linear_1897_1301)"
    />
    <path
      d="M591 235.499H1027.93C1047.85 235.499 1064 219.349 1064 199.426V199.426C1064 179.504 1047.85 163.354 1027.93 163.354L907.514 163.354C889.005 163.354 874 148.349 874 129.839V129.839C874 111.33 889.005 96.3249 907.514 96.3249L976.404 96.3249C996.892 96.3249 1013.5 79.7165 1013.5 59.2289V59.2289C1013.5 38.7413 996.892 22.1328 976.404 22.1328L637 22.1328"
      stroke="#B7B8E3"
    />
    <g filter="url(#filter0_d_1897_1301)">
      <rect x="702" y="1" width="42" height="42" rx="21" fill="#EDE9FE" />
      <path
        d="M719 22C718.868 22 718.739 22.0391 718.63 22.1124C718.52 22.1856 718.434 22.2897 718.384 22.4116C718.334 22.5334 718.32 22.6674 718.346 22.7967C718.372 22.9261 718.435 23.0448 718.529 23.1381C718.622 23.2313 718.741 23.2948 718.87 23.3205C718.999 23.3463 719.133 23.3331 719.255 23.2826C719.377 23.2321 719.481 23.1467 719.554 23.0371C719.628 22.9274 719.667 22.7985 719.667 22.6667C719.667 22.4899 719.596 22.3203 719.471 22.1953C719.346 22.0702 719.177 22 719 22ZM714.333 21.3333C714.156 21.3333 713.987 21.4036 713.862 21.5286C713.737 21.6536 713.667 21.8232 713.667 22V23.3333C713.667 23.5102 713.737 23.6797 713.862 23.8047C713.987 23.9298 714.156 24 714.333 24C714.51 24 714.68 23.9298 714.805 23.8047C714.93 23.6797 715 23.5102 715 23.3333V22C715 21.8232 714.93 21.6536 714.805 21.5286C714.68 21.4036 714.51 21.3333 714.333 21.3333ZM727.667 21.3333C727.49 21.3333 727.32 21.4036 727.195 21.5286C727.07 21.6536 727 21.8232 727 22V23.3333C727 23.5102 727.07 23.6797 727.195 23.8047C727.32 23.9298 727.49 24 727.667 24C727.843 24 728.013 23.9298 728.138 23.8047C728.263 23.6797 728.333 23.5102 728.333 23.3333V22C728.333 21.8232 728.263 21.6536 728.138 21.5286C728.013 21.4036 727.843 21.3333 727.667 21.3333ZM724.333 16.6667H721.667V15.8133C721.868 15.697 722.036 15.53 722.153 15.3288C722.27 15.1276 722.332 14.8994 722.333 14.6667C722.333 14.3131 722.193 13.9739 721.943 13.7239C721.693 13.4738 721.354 13.3333 721 13.3333C720.646 13.3333 720.307 13.4738 720.057 13.7239C719.807 13.9739 719.667 14.3131 719.667 14.6667C719.668 14.8994 719.73 15.1276 719.847 15.3288C719.964 15.53 720.132 15.697 720.333 15.8133V16.6667H717.667C717.136 16.6667 716.627 16.8774 716.252 17.2525C715.877 17.6275 715.667 18.1362 715.667 18.6667V24.6667C715.667 25.1971 715.877 25.7058 716.252 26.0809C716.627 26.456 717.136 26.6667 717.667 26.6667H724.333C724.864 26.6667 725.372 26.456 725.748 26.0809C726.123 25.7058 726.333 25.1971 726.333 24.6667V18.6667C726.333 18.1362 726.123 17.6275 725.748 17.2525C725.372 16.8774 724.864 16.6667 724.333 16.6667ZM722.147 18L721.813 19.3333H720.187L719.853 18H722.147ZM725 24.6667C725 24.8435 724.93 25.0131 724.805 25.1381C724.68 25.2631 724.51 25.3333 724.333 25.3333H717.667C717.49 25.3333 717.32 25.2631 717.195 25.1381C717.07 25.0131 717 24.8435 717 24.6667V18.6667C717 18.4899 717.07 18.3203 717.195 18.1953C717.32 18.0702 717.49 18 717.667 18H718.48L719 20.16C719.036 20.3079 719.123 20.4389 719.244 20.5311C719.365 20.6233 719.514 20.6711 719.667 20.6667H722.333C722.486 20.6711 722.635 20.6233 722.756 20.5311C722.877 20.4389 722.963 20.3079 723 20.16L723.52 18H724.333C724.51 18 724.68 18.0702 724.805 18.1953C724.93 18.3203 725 18.4899 725 18.6667V24.6667ZM723 22C722.868 22 722.739 22.0391 722.63 22.1124C722.52 22.1856 722.434 22.2897 722.384 22.4116C722.334 22.5334 722.32 22.6674 722.346 22.7967C722.372 22.9261 722.435 23.0448 722.529 23.1381C722.622 23.2313 722.741 23.2948 722.87 23.3205C722.999 23.3463 723.133 23.3331 723.255 23.2826C723.377 23.2321 723.481 23.1467 723.554 23.0371C723.628 22.9274 723.667 22.7985 723.667 22.6667C723.667 22.4899 723.596 22.3203 723.471 22.1953C723.346 22.0702 723.177 22 723 22Z"
        fill="#7C3AED"
      />
      <circle cx="727" cy="26.0001" r="3.41949" fill="#EDE9FE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M727 30.8C728.273 30.8 729.494 30.2943 730.394 29.3941C731.294 28.494 731.8 27.2731 731.8 26C731.8 24.727 731.294 23.5061 730.394 22.6059C729.494 21.7057 728.273 21.2 727 21.2C725.727 21.2 724.506 21.7057 723.606 22.6059C722.706 23.5061 722.2 24.727 722.2 26C722.2 27.2731 722.706 28.494 723.606 29.3941C724.506 30.2943 725.727 30.8 727 30.8ZM727.6 23.6C727.6 23.4409 727.537 23.2883 727.424 23.1757C727.312 23.0632 727.159 23 727 23C726.841 23 726.688 23.0632 726.576 23.1757C726.463 23.2883 726.4 23.4409 726.4 23.6V26C726.4 26.1591 726.463 26.3117 726.576 26.4242L728.273 28.1216C728.328 28.1774 728.394 28.2216 728.467 28.2517C728.54 28.2819 728.618 28.2974 728.697 28.2974C728.776 28.2974 728.854 28.2819 728.927 28.2517C729 28.2216 729.066 28.1774 729.122 28.1216C729.177 28.0659 729.222 27.9997 729.252 27.9269C729.282 27.854 729.297 27.7759 729.297 27.6971C729.297 27.6183 729.282 27.5402 729.252 27.4674C729.222 27.3945 729.177 27.3284 729.122 27.2726L727.6 25.7516V23.6Z"
        fill="#7C3AED"
      />
    </g>
    <g filter="url(#filter1_d_1897_1301)">
      <rect x="846" y="14" width="16" height="16" rx="8" fill="#DDD6FE" />
      <circle cx="854" cy="22" r="4.5" fill="#8B5CF6" />
    </g>
    <g opacity="0.9">
      <rect x="48" y="57" width="637" height="44" rx="4" fill="#EEF2FF" />
      <path
        d="M79.2727 80.3182C79.0929 80.3182 78.9172 80.3715 78.7677 80.4714C78.6182 80.5713 78.5016 80.7133 78.4328 80.8794C78.364 81.0455 78.346 81.2283 78.3811 81.4046C78.4162 81.581 78.5028 81.743 78.6299 81.8701C78.757 81.9973 78.919 82.0838 79.0954 82.1189C79.2717 82.154 79.4545 82.136 79.6206 82.0672C79.7867 81.9984 79.9287 81.8818 80.0286 81.7324C80.1285 81.5828 80.1818 81.4071 80.1818 81.2273C80.1818 80.9862 80.086 80.7549 79.9156 80.5845C79.7451 80.414 79.5138 80.3182 79.2727 80.3182ZM72.9091 79.4091C72.668 79.4091 72.4368 79.5049 72.2663 79.6754C72.0958 79.8458 72 80.0771 72 80.3182V82.1364C72 82.3775 72.0958 82.6087 72.2663 82.7792C72.4368 82.9496 72.668 83.0455 72.9091 83.0455C73.1502 83.0455 73.3814 82.9496 73.5519 82.7792C73.7224 82.6087 73.8182 82.3775 73.8182 82.1364V80.3182C73.8182 80.0771 73.7224 79.8458 73.5519 79.6754C73.3814 79.5049 73.1502 79.4091 72.9091 79.4091ZM91.0909 79.4091C90.8498 79.4091 90.6185 79.5049 90.4481 79.6754C90.2776 79.8458 90.1818 80.0771 90.1818 80.3182V82.1364C90.1818 82.3775 90.2776 82.6087 90.4481 82.7792C90.6185 82.9496 90.8498 83.0455 91.0909 83.0455C91.332 83.0455 91.5633 82.9496 91.7337 82.7792C91.9042 82.6087 92 82.3775 92 82.1364V80.3182C92 80.0771 91.9042 79.8458 91.7337 79.6754C91.5633 79.5049 91.332 79.4091 91.0909 79.4091ZM86.5455 73.0455H82.9091V71.8818C83.1839 71.7232 83.4124 71.4954 83.5719 71.2211C83.7314 70.9468 83.8163 70.6355 83.8182 70.3182C83.8182 69.836 83.6266 69.3735 83.2856 69.0325C82.9446 68.6916 82.4822 68.5 82 68.5C81.5178 68.5 81.0554 68.6916 80.7144 69.0325C80.3734 69.3735 80.1818 69.836 80.1818 70.3182C80.1837 70.6355 80.2686 70.9468 80.4281 71.2211C80.5876 71.4954 80.8161 71.7232 81.0909 71.8818V73.0455H77.4545C76.7312 73.0455 76.0375 73.3328 75.5261 73.8443C75.0146 74.3557 74.7273 75.0494 74.7273 75.7727V83.9545C74.7273 84.6778 75.0146 85.3715 75.5261 85.883C76.0375 86.3945 76.7312 86.6818 77.4545 86.6818H86.5455C87.2687 86.6818 87.9625 86.3945 88.4739 85.883C88.9854 85.3715 89.2727 84.6778 89.2727 83.9545V75.7727C89.2727 75.0494 88.9854 74.3557 88.4739 73.8443C87.9625 73.3328 87.2687 73.0455 86.5455 73.0455ZM83.5636 74.8636L83.1091 76.6818H80.8909L80.4364 74.8636H83.5636ZM87.4545 83.9545C87.4545 84.1956 87.3587 84.4269 87.1883 84.5974C87.0178 84.7678 86.7865 84.8636 86.5455 84.8636H77.4545C77.2134 84.8636 76.9822 84.7678 76.8117 84.5974C76.6412 84.4269 76.5455 84.1956 76.5455 83.9545V75.7727C76.5455 75.5316 76.6412 75.3004 76.8117 75.1299C76.9822 74.9594 77.2134 74.8636 77.4545 74.8636H78.5636L79.2727 77.8091C79.3225 78.0108 79.4399 78.1894 79.6053 78.3151C79.7707 78.4408 79.9742 78.5061 80.1818 78.5H83.8182C84.0258 78.5061 84.2294 78.4408 84.3947 78.3151C84.5602 78.1894 84.6775 78.0108 84.7273 77.8091L85.4364 74.8636H86.5455C86.7865 74.8636 87.0178 74.9594 87.1883 75.1299C87.3587 75.3004 87.4545 75.5316 87.4545 75.7727V83.9545ZM84.7273 80.3182C84.5475 80.3182 84.3717 80.3715 84.2222 80.4714C84.0727 80.5713 83.9562 80.7133 83.8874 80.8794C83.8185 81.0455 83.8005 81.2283 83.8356 81.4046C83.8707 81.581 83.9573 81.743 84.0845 81.8701C84.2115 81.9973 84.3735 82.0838 84.5499 82.1189C84.7263 82.154 84.9091 82.136 85.0752 82.0672C85.2413 81.9984 85.3833 81.8818 85.4832 81.7324C85.5831 81.5828 85.6364 81.4071 85.6364 81.2273C85.6364 80.9862 85.5405 80.7549 85.3701 80.5845C85.1996 80.414 84.9684 80.3182 84.7273 80.3182Z"
        fill="#5B21B6"
      />
      <text
        fill="#5B21B6"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        className="font-sans"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="104" y="83.97">
          Add Unemployment Tax to your Payroll Provider
        </tspan>
      </text>
      <text
        fill="#6D28D9"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        className="font-sans"
        fontSize="12"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="579" y="83.26">
          AUTOMATED
        </tspan>
      </text>
    </g>
    <g opacity="0.1">
      <path
        d="M258 295.667V299L260.5 301.5M265.5 299C265.5 299.985 265.306 300.96 264.929 301.87C264.552 302.78 264 303.607 263.303 304.303C262.607 305 261.78 305.552 260.87 305.929C259.96 306.306 258.985 306.5 258 306.5C257.015 306.5 256.04 306.306 255.13 305.929C254.22 305.552 253.393 305 252.697 304.303C252 303.607 251.448 302.78 251.071 301.87C250.694 300.96 250.5 299.985 250.5 299C250.5 297.011 251.29 295.103 252.697 293.697C254.103 292.29 256.011 291.5 258 291.5C259.989 291.5 261.897 292.29 263.303 293.697C264.71 295.103 265.5 297.011 265.5 299Z"
        stroke="#006265"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="276"
        y="293.5"
        width="164"
        height="11"
        rx="2"
        fill="#134E4A"
        fillOpacity="0.2"
      />
    </g>
    <g opacity="0.05">
      <rect x="288" y="321" width="637" height="44" rx="4" fill="#E2EBEB" />
      <path
        d="M319.5 343L321.167 344.667L324.5 341.333M329.5 343C329.5 343.985 329.306 344.96 328.929 345.87C328.552 346.78 328 347.607 327.303 348.303C326.607 349 325.78 349.552 324.87 349.929C323.96 350.306 322.985 350.5 322 350.5C321.015 350.5 320.04 350.306 319.13 349.929C318.22 349.552 317.393 349 316.697 348.303C316 347.607 315.448 346.78 315.071 345.87C314.694 344.96 314.5 343.985 314.5 343C314.5 341.011 315.29 339.103 316.697 337.697C318.103 336.29 320.011 335.5 322 335.5C323.989 335.5 325.897 336.29 327.303 337.697C328.71 339.103 329.5 341.011 329.5 343Z"
        stroke="#006265"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="340"
        y="335"
        width="447"
        height="16"
        rx="2"
        fill="#134E4A"
        fillOpacity="0.2"
      />
    </g>
    <g filter="url(#filter2_d_1897_1301)">
      <rect x="569" y="211" width="50" height="51" rx="25" fill="#8B5CF6" />
      <path
        d="M587.535 236.5C587.322 236.5 587.113 236.563 586.936 236.682C586.759 236.8 586.621 236.968 586.539 237.165C586.458 237.362 586.436 237.579 586.478 237.788C586.52 237.997 586.622 238.189 586.773 238.339C586.924 238.49 587.116 238.593 587.325 238.634C587.534 238.676 587.75 238.655 587.947 238.573C588.144 238.491 588.312 238.353 588.431 238.176C588.549 237.999 588.612 237.791 588.612 237.578C588.612 237.292 588.499 237.018 588.297 236.816C588.095 236.614 587.821 236.5 587.535 236.5ZM579.992 235.422C579.706 235.422 579.432 235.536 579.23 235.738C579.028 235.94 578.915 236.214 578.915 236.5V238.655C578.915 238.941 579.028 239.215 579.23 239.417C579.432 239.619 579.706 239.733 579.992 239.733C580.278 239.733 580.552 239.619 580.754 239.417C580.956 239.215 581.07 238.941 581.07 238.655V236.5C581.07 236.214 580.956 235.94 580.754 235.738C580.552 235.536 580.278 235.422 579.992 235.422ZM601.543 235.422C601.257 235.422 600.983 235.536 600.781 235.738C600.579 235.94 600.465 236.214 600.465 236.5V238.655C600.465 238.941 600.579 239.215 600.781 239.417C600.983 239.619 601.257 239.733 601.543 239.733C601.828 239.733 602.103 239.619 602.305 239.417C602.507 239.215 602.62 238.941 602.62 238.655V236.5C602.62 236.214 602.507 235.94 602.305 235.738C602.103 235.536 601.828 235.422 601.543 235.422ZM596.155 227.88H591.845V226.501C592.171 226.313 592.441 226.043 592.631 225.717C592.82 225.392 592.92 225.023 592.922 224.647C592.922 224.076 592.695 223.528 592.291 223.123C591.887 222.719 591.339 222.492 590.767 222.492C590.196 222.492 589.648 222.719 589.244 223.123C588.839 223.528 588.612 224.076 588.612 224.647C588.615 225.023 588.715 225.392 588.904 225.717C589.093 226.043 589.364 226.313 589.69 226.501V227.88H585.38C584.522 227.88 583.7 228.22 583.094 228.827C582.488 229.433 582.147 230.255 582.147 231.112V240.81C582.147 241.667 582.488 242.49 583.094 243.096C583.7 243.702 584.522 244.043 585.38 244.043H596.155C597.012 244.043 597.835 243.702 598.441 243.096C599.047 242.49 599.388 241.667 599.388 240.81V231.112C599.388 230.255 599.047 229.433 598.441 228.827C597.835 228.22 597.012 227.88 596.155 227.88ZM592.621 230.035L592.082 232.19H589.453L588.914 230.035H592.621ZM597.233 240.81C597.233 241.096 597.119 241.37 596.917 241.572C596.715 241.774 596.441 241.888 596.155 241.888H585.38C585.094 241.888 584.82 241.774 584.618 241.572C584.416 241.37 584.302 241.096 584.302 240.81V231.112C584.302 230.827 584.416 230.553 584.618 230.35C584.82 230.148 585.094 230.035 585.38 230.035H586.694L587.535 233.526C587.594 233.765 587.733 233.977 587.929 234.126C588.125 234.275 588.366 234.352 588.612 234.345H592.922C593.169 234.352 593.41 234.275 593.606 234.126C593.802 233.977 593.941 233.765 594 233.526L594.84 230.035H596.155C596.441 230.035 596.715 230.148 596.917 230.35C597.119 230.553 597.233 230.827 597.233 231.112V240.81ZM594 236.5C593.787 236.5 593.579 236.563 593.401 236.682C593.224 236.8 593.086 236.968 593.004 237.165C592.923 237.362 592.902 237.579 592.943 237.788C592.985 237.997 593.087 238.189 593.238 238.339C593.389 238.49 593.581 238.593 593.79 238.634C593.999 238.676 594.215 238.655 594.412 238.573C594.609 238.491 594.778 238.353 594.896 238.176C595.014 237.999 595.078 237.791 595.078 237.578C595.078 237.292 594.964 237.018 594.762 236.816C594.56 236.614 594.286 236.5 594 236.5Z"
        fill="#EDE9FE"
      />
      <circle cx="600.869" cy="242.561" r="7.35397" fill="#8B5CF6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M600.465 250.723C602.523 250.723 604.496 249.906 605.951 248.451C607.406 246.996 608.223 245.023 608.223 242.965C608.223 240.908 607.406 238.934 605.951 237.479C604.496 236.024 602.523 235.207 600.465 235.207C598.408 235.207 596.434 236.024 594.979 237.479C593.524 238.934 592.707 240.908 592.707 242.965C592.707 245.023 593.524 246.996 594.979 248.451C596.434 249.906 598.408 250.723 600.465 250.723ZM604.06 241.711C604.237 241.528 604.335 241.283 604.332 241.029C604.33 240.775 604.228 240.532 604.048 240.352C603.869 240.172 603.625 240.07 603.371 240.068C603.117 240.066 602.872 240.163 602.689 240.34L599.495 243.533L598.242 242.28C598.059 242.103 597.814 242.005 597.559 242.007C597.305 242.01 597.062 242.112 596.882 242.291C596.702 242.471 596.6 242.714 596.598 242.969C596.596 243.223 596.694 243.468 596.87 243.651L598.81 245.59C598.992 245.772 599.238 245.874 599.495 245.874C599.753 245.874 599.999 245.772 600.181 245.59L604.06 241.711Z"
        fill="#EDE9FE"
      />
    </g>
    <g filter="url(#filter3_d_1897_1301)">
      <rect x="872" y="140" width="16" height="16" rx="8" fill="#DDD6FE" />
      <circle cx="880" cy="148" r="4.5" fill="#8B5CF6" />
    </g>
    <g filter="url(#filter4_d_1897_1301)">
      <rect x="953" y="228" width="16" height="16" rx="8" fill="#DDD6FE" />
      <circle cx="961" cy="236" r="4.5" fill="#8B5CF6" />
    </g>
    <g filter="url(#filter5_d_1897_1301)">
      <rect x="729" y="228" width="16" height="16" rx="8" fill="#DDD6FE" />
      <circle cx="737" cy="236" r="4.5" fill="#8B5CF6" />
    </g>
    <g filter="url(#filter6_d_1897_1301)">
      <rect x="936" y="88" width="16" height="16" rx="8" fill="#DDD6FE" />
      <circle cx="944" cy="96" r="4.5" fill="#8B5CF6" />
    </g>
    <g opacity="0.7">
      <path
        d="M5.20782 46.8086L5.20788 64.6636C5.2079 72.1477 11.2749 78.2147 18.759 78.2147V78.2147L30.1138 78.2147L44.2102 78.2147"
        stroke="#7F9591"
        strokeWidth="1.5"
        strokeMiterlimit="5.75877"
        strokeDasharray="3 3"
      />
      <path
        d="M5.18565 55.5082L5.2209 50.3174M5.18565 55.5082L6.16546 54.4236M5.18565 55.5082L4.08129 54.363"
        stroke="#008489"
        strokeWidth="1.4125"
        strokeLinecap="round"
      />
      <g filter="url(#filter7_d_1897_1301)">
        <rect x="22" y="72" width="11" height="11" rx="5.5" fill="#B0D3D4" />
        <circle cx="27.5" cy="77.5" r="3.5" fill="#008489" />
      </g>
    </g>
    <g opacity="0.6">
      <path
        d="M64.6736 104.309L64.6737 122.164C64.6737 129.648 70.7408 135.715 78.2248 135.715V135.715L89.5796 135.715L103.676 135.715"
        stroke="#A78BFA"
        strokeWidth="1.5"
        strokeMiterlimit="5.75877"
        strokeDasharray="3 3"
      />
      <g filter="url(#filter8_d_1897_1301)">
        <rect x="81" y="130" width="11" height="11" rx="5.5" fill="#DDD6FE" />
        <circle cx="86.5" cy="135.5" r="3.5" fill="#8B5CF6" />
      </g>
      <path
        d="M64.6515 113.008L64.6867 107.817M64.6515 113.008L65.6313 111.924M64.6515 113.008L63.5471 111.863"
        stroke="#8B5CF6"
        strokeWidth="1.4125"
        strokeLinecap="round"
      />
    </g>
    <g opacity="0.4" clipPath="url(#clip0_1897_1301)">
      <path
        d="M120.998 157.735L120.998 175.59C120.998 183.074 127.065 189.141 134.549 189.141V189.141L145.904 189.141L160 189.141"
        stroke="#A78BFA"
        strokeWidth="1.5"
        strokeMiterlimit="5.75877"
        strokeDasharray="3 3"
      />
      <g filter="url(#filter9_d_1897_1301)">
        <rect x="137" y="183" width="11" height="11" rx="5.5" fill="#DDD6FE" />
        <circle cx="142.5" cy="188.5" r="3.5" fill="#8B5CF6" />
      </g>
      <path
        d="M120.976 166.435L121.011 161.244M120.976 166.435L121.955 165.35M120.976 166.435L119.871 165.29"
        stroke="#8B5CF6"
        strokeWidth="1.4125"
        strokeLinecap="round"
      />
    </g>
    <g opacity="0.3">
      <path
        d="M175.998 213L175.998 230.855C175.998 238.339 182.065 244.406 189.549 244.406V244.406L200.904 244.406L215 244.406"
        stroke="#A78BFA"
        strokeWidth="1.5"
        strokeMiterlimit="5.75877"
        strokeDasharray="3 3"
      />
      <path
        d="M175.976 221.7L176.011 216.509M175.976 221.7L176.955 220.615M175.976 221.7L174.871 220.554"
        stroke="#8B5CF6"
        strokeWidth="1.4125"
        strokeLinecap="round"
      />
      <g filter="url(#filter10_d_1897_1301)">
        <rect x="192" y="239" width="11" height="11" rx="5.5" fill="#DDD6FE" />
        <circle cx="197.5" cy="244.5" r="3.5" fill="#8B5CF6" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1897_1301"
        x="700"
        y="0"
        width="46"
        height="46"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1897_1301"
        x="844"
        y="13"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_1897_1301"
        x="567"
        y="210"
        width="54"
        height="55"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_1897_1301"
        x="870"
        y="139"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_1897_1301"
        x="951"
        y="227"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_1897_1301"
        x="727"
        y="227"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_1897_1301"
        x="934"
        y="87"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d_1897_1301"
        x="19.5"
        y="70.5"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_d_1897_1301"
        x="78.5"
        y="128.5"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_d_1897_1301"
        x="134.5"
        y="181.5"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_d_1897_1301"
        x="189.5"
        y="237.5"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1897_1301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1897_1301"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1897_1301"
        x1="288"
        y1="298.333"
        x2="829.277"
        y2="298.333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F6FAFA" stopOpacity="0" />
        <stop offset="0.915" stopColor="#F7FBFB" />
      </linearGradient>
      <clipPath id="clip0_1897_1301">
        <rect
          width="41.5759"
          height="36.2646"
          fill="white"
          transform="translate(118.424 157.735)"
        />
      </clipPath>
    </defs>
  </svg>
);
